<template>
    <div class="entity-compare">
        <v-row class="entity-compare-header m-0">
            <v-col cols="6" class="header-col left"><h4>Before</h4></v-col>
            <v-col cols="6" class="header-col right"><h4>After</h4></v-col>
        </v-row>
        <v-row class="entity-compare-body m-0">
            <v-col cols="6" class="body-col left">
                <notification-collection-centres-approval-request-form
                    :store="collectionCentre"
                    :is-afert="true"
                ></notification-collection-centres-approval-request-form>
            </v-col>

            <v-col cols="6" class="body-col right">
                <notification-collection-centres-approval-request-form
                    :store="collectionCentreSnapShot"
                ></notification-collection-centres-approval-request-form>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: 'NotificationCollectionCentreApprovalRequest',
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {
        notification() {
            return this.$store.state.notifications.current;
        },
        collectionCentre() {
            return this.$store.state.notification_laboratory.collection_centre;
        },
        collectionCentreSnapShot() {
            return this.$store.state.notification_laboratory.collection_centreSnapShot;
        },
    },
    watch: {},
    created() {},
    methods: {},
};
</script>
